import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-cms-skeleton',
  templateUrl: './cms-skeleton.component.html',
  styleUrls: ['./cms-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgxSkeletonLoaderModule],
})
export class CmsSkeletonComponent {
}
